// extracted by mini-css-extract-plugin
export var menuIcon = "_o4-0";
export var menuIconInline = "_o4-1";